// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__23_mT","approved":"Status_approved__3WgvA","rejected":"Status_rejected__3U-Ux","expired":"Status_expired__H9wp5","label":"Status_label__2gozB"};